import map from './map';
import switchLatest from './switch-latest';
export default function switchMap(iteratee, stream) {
    return switchLatest(map(iteratee, stream));
}
//# sourceMappingURL=switch-map.js.map